import { Component, OnInit } from '@angular/core';
import { User } from '../models/User';
import { AccountService } from '../services/account.service';
import { element } from 'protractor';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  user: User;

  collapsed = true;

 

  constructor(
    private _accountService: AccountService
  ){
    this._accountService.user.subscribe(
      result => {
        this.user = result;
        console.log('USER: ',result);
        
      }
      
    )
  }

  logout(){
    this._accountService.logout();
  }

  ngOnInit(): void {
  }

  clickEvent(){
    if (this.collapsed){
      this.collapsed = false
    } else {
      this.collapsed = true;
    }
  }

}
